import * as tslib_1 from "tslib";
import { useState, useMemo } from 'react';
var useMap = function (initialMap) {
    if (initialMap === void 0) { initialMap = {}; }
    var _a = useState(initialMap), map = _a[0], set = _a[1];
    var utils = useMemo(function () { return ({
        get: function (key) { return map[key]; },
        set: function (key, entry) {
            set(function (prevMap) {
                var _a;
                return (tslib_1.__assign({}, prevMap, (_a = {}, _a[key] = entry, _a)));
            });
        },
        remove: function (key) {
            set(function (prevMap) {
                var _a = key, omit = prevMap[_a], rest = tslib_1.__rest(prevMap, [typeof _a === "symbol" ? _a : _a + ""]);
                return rest;
            });
        },
        reset: function () { return set(initialMap); },
    }); }, [set]);
    return [map, utils];
};
export default useMap;
